import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToleranciaISOParaDiametroInterior } from 'src/app/constants/tablas-utiles';
import { advertisement, ServiceService } from 'src/app/service.service';
import { UtilsService } from '../../utils.service';

@Component({
  selector: 'app-toler-iso-di',
  templateUrl: './toler-iso-di.page.html',
  styleUrls: ['./toler-iso-di.page.scss'],
})
export class TolerIsoDIPage implements OnInit {
  public tolIntForm:FormGroup = null;
  public tolerancesForInsideDiameter:Array<any> = [];
  public grades:Array<any> = [];
  public response:string = '';
  previousResult:string = null;
  isMovil:boolean = false;
  advertisements:advertisement = new advertisement();

  constructor(public services:ServiceService, private formBuilder:FormBuilder,private _utils: UtilsService) {
    this.tolerancesForInsideDiameter = [...ToleranciaISOParaDiametroInterior];
  }

  async ngOnInit() {
    this.tolIntForm = this.formBuilder.group({
      diameter: ['', Validators.required ],
      grade: ['', Validators.required ],
    });
    this.isMovil = this.services.isMovil();
    if(!this.isMovil){
      this.advertisements = await this.services.getAdvertisementByScreen(8,1);
      this.advertisements.Displayed = this.advertisements.MediaBasico.slice(0,this.advertisements.Rows);
      this.advertisements.Random = this.services.NumberRandom(this.advertisements.Principal.length);
      this.services.postAdvertisementUser(this.advertisements.getAllRelAdsMetricsIdDisplayed());
    }
  }

  onChangediameter(ev:any){
    this.grades = [];
    this.tolIntForm.controls.grade.setValue(undefined);
    // this.response = '';
    if(ev.target.value!=null){
      this.grades = [...this.tolerancesForInsideDiameter[ev.target.value].grados];
    }
  }

  reset(){
    this.tolIntForm.reset();
    this.response = '';
  }
  isSharing:boolean = false;
  calcular(){
    if(!this.tolIntForm.valid)
      return;
      
    let gradeSelected = this.grades[this.tolIntForm.controls.grade.value];
    let max:number = gradeSelected.maximo*(Math.pow(10,-3));
    let min:number = gradeSelected.minimo*(Math.pow(10,-3));
    this.response = `<br>Máximo = ${gradeSelected.maximo}x(10¯³) = ${this._utils.roundDecimals(max,4)}mm<br>
    Mínimo = ${gradeSelected.minimo}x(10¯³) = ${this._utils.roundDecimals(min,4)}mm`;
    // despues de procesar respuesta
    if(this.previousResult != this.response && !this.isSharing){
      this.previousResult = this.response;
      this.isSharing = true;
      setTimeout(()=>{ this.isSharing = false; },20000);
      this.services.addPointCalculator();
    }
  }

}
